import React from "react"

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import BlackduckBinaryAnalysisConfigListing from "./BlackduckBinaryAnalysisConfigListing";
import BlackduckBinaryAnalysisCredentialsForm from "./BlackduckBinaryAnalysisCredentialsForm";

const BlackduckBinaryAnalysisPullAndPushView = (props) => {
    return (
        <GenericPullAndPushToolView
            {...props}
            PullCredentialForm={BlackduckBinaryAnalysisCredentialsForm}
            PullConfigListingView={BlackduckBinaryAnalysisConfigListing}
        />
    );
};

export default BlackduckBinaryAnalysisPullAndPushView;